import {Component, computed, EventEmitter, inject, Input, Output, ViewEncapsulation} from '@angular/core';
import {IBarClickedEvent} from './bar-click-event.interface';
import {
  ICartStatus,
  ICartStatusClientAccess,
  ICartStatusOnHold, ICartStatusUncollectible,
  StatusTuple
} from '../../../../config/cart-status-data.interface';
import {CalculusStore} from '../../../../../Services/calculus.store';
import {ProcessOverviewStore} from '../../service/process-overview.store';
import {NgFor} from '@angular/common';

@Component({
  selector: 'kpi4me-evaluation',
  templateUrl: './evaluation.component.html',
  styleUrls: ['./evaluation.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: true,
  imports: [NgFor]
})
export class EvaluationComponent {
  private _calculusService = inject(CalculusStore);
  private _processOverviewService = inject(ProcessOverviewStore);

  @Input() process: ICartStatus | ICartStatusOnHold | ICartStatusClientAccess | ICartStatusUncollectible;
  @Output() barClicked = new EventEmitter<IBarClickedEvent>();
  protected _evaluationData: [number] | StatusTuple;
  protected evaluationDisplayPercentages: [string] | [string, string, string];
  protected evaluationDisplayAbsolute: [string] | [string, string, string];

  showPercentages = this._calculusService.showPercentages;
  selectedState = computed(() => this._processOverviewService.selectedProcess().state);

  @Input() set evaluationData(data: StatusTuple | [number]) {
    if (!data?.length) return;

    const nonNegativeData = data.map((value: number): number => {
      if (value < 0) {
        console.error('Received invalid data: negative value');
        return 0;
      }
      return value;
    });

    const inputSum: number = nonNegativeData.reduce((previousValue, currentValue) => previousValue + currentValue, 0);
    if (inputSum > 0) {
      const average = nonNegativeData.map((value: number) => {
        return Math.round(value / inputSum * 100);
      });
      this._evaluationData = average.length === 1 ? average as [number] : average as StatusTuple;
    } else {
      this._evaluationData = data.length === 1 ? [0] : [0, 0, 0];
    }

    this.evaluationDisplayPercentages = this._evaluationData.map((num) => {
      return num.toString() + '%';
    }) as [string, string, string];
    this.evaluationDisplayAbsolute = nonNegativeData.map((value: number) => {
      return this.generateDisplay(value);
    }) as [string, string, string];
  }


  private generateDisplay(value: number): string {
    if (value < 1000) {
      return value.toString();
    } else if (value < 10000) {
      return (Math.round(value / 100) / 10).toString() + 'k';
    } else if (value < 1000000) {
      return (Math.round(value / 1000)).toString() + 'k';
    } else if (value < 10000000) {
      return (Math.round(value / 100000) / 10).toString() + 'M';
    } else {
      return (Math.round(value / 1000000)).toString() + 'M';
    }
  }

  getStateByIndex(i: number) {
    switch (i) {
      case 0:
        return this.process.errorId;
      case 1:
        return this.process.warningId;
      case 2:
        return this.process.okId;
      default:
        throw new Error("Unexpected state index")
    }
  }
}
